import { colours } from '@headbox-ui/themes'

const { brick, grey } = colours

export const avatar = {
  backgroundColor: brick[600],
  color: brick[100],
  cursor: 'pointer',
  letterSpacing: 1,
  marginLeft: 20
}

export const dropDown = {
  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
  border: `1px solid ${grey[99] as string}`,
  paddingTop: 0
}
